@let _marketsLength = marketsLength();
@if (!router.url.includes("highlights")) {
  <div class="header">
    <span class="title"> {{ pageTitle | translate }} </span>
  </div>
}
@if (_marketsLength > 0) {
  <select [disabled]="!leagues.length" [value]="selectedLeague" class="league-filter" (change)="handleLeagueFilter($event)">
    @for (league of leagues; track league.id) {
      <option [value]="league.id">{{ league.name }}</option>
    }
  </select>
}
@if (_marketsLength === 0 && !($loading | async) && !isLoadingStatus()) {
  <app-alert
    [config]="{
      title: 'No Upcoming Events.',
      subtitle: 'There are no upcoming events.',
      type: 'info',
    }" />
}
<app-highlight-loader [show]="_marketsLength === 0 && (($loading | async) || isLoadingStatus())" />
@if (_marketsLength > 0) {
  <div class="highlight-content">
    <table>
      <thead>
        <tr>
          <th>
            <div class="e-th">
              <span> {{ "Event" | translate }} </span>
              <button
                (click)="onSort('eventName')"
                class="sort-btn"
                [matTooltip]="currentSort?.field === 'eventName' ? (currentSort?.order === 'asc' ? 'Sort descending' : 'Clear sorting') : 'Sort ascending'">
                <mat-icon>
                  {{ currentSort?.field === "eventName" ? (currentSort?.order === "asc" ? "keyboard_arrow_up" : "close") : "unfold_more" }}
                </mat-icon>
              </button>
            </div>
          </th>
          <th>
            <div class="matched-th">
              <span> {{ "Matched" | translate }} </span>
              <button
                (click)="onSort('totalMatched')"
                class="sort-btn"
                [matTooltip]="currentSort?.field === 'totalMatched' ? (currentSort?.order === 'asc' ? 'Sort descending' : 'Clear sorting') : 'Sort ascending'">
                <mat-icon>
                  {{ currentSort?.field === "totalMatched" ? (currentSort?.order === "asc" ? "keyboard_arrow_up" : "close") : "unfold_more" }}
                </mat-icon>
              </button>
            </div>
          </th>
          @for (item of tHeaders; track item) {
            <th colspan="2">{{ item | translate }}</th>
          }
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (market of markets(); track market?.marketId) {
          <tr app-h-row [market]="market"></tr>
        }
      </tbody>
    </table>
  </div>
}
